import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, TextField } from '@mui/material';
import { useSnackbar } from 'notistack';
import { setLoading } from 'Actions/loading';
import { setFlow } from 'Actions/flow';
import { CustomSnackbar } from 'Shared/CustomSnackbar';
import http from 'Utils/http';
import { useCreateUrl } from 'Hooks/useCreateUrl';
import { process } from 'Utils/errorHandler';

const toFormValues = (flow) => ({ timeout: flow?.timeout ?? '' });

export const FlowTimeoutForm = () => {
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const { createUrl } = useCreateUrl();
    const flow = useSelector((state) => state.flow.flow);

    const { register, handleSubmit, reset, formState: { isDirty } } = useForm({ defaultValues: toFormValues(flow) });

    useEffect(() => {
        reset(toFormValues(flow));
    }, [flow, reset]);

    const onSubmit = (data) => {
        dispatch(setLoading(true));
        http.post(createUrl(`/flow/${flow.id}/update`), { timeout: data.timeout === '' ? 'null' : String(data.timeout) }).then((res) => {
            dispatch(setFlow(res.data.flow));
            enqueueSnackbar('Flow timeout has been updated', {
                action: CustomSnackbar,
                variant: 'success'
            });
        }).catch((err) => {
            process(err, enqueueSnackbar);
        }).finally(() => {
            dispatch(setLoading(false));
        });
    };

    return (
        <Box component="form" onSubmit={handleSubmit(onSubmit)} sx={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
            <TextField
                id="timeout"
                label="Timeout, sec"
                type="number"
                placeholder="Server limit"
                fullWidth
                inputProps={{ min: 0 }}
                InputLabelProps={{ shrink: true }}
                {...register('timeout', { min: 0 })}
            />
            <Button type="submit" variant="contained" disabled={!isDirty} sx={{ height: '56px' }}>
                Save
            </Button>
        </Box>
    );
};
